var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1917 18.0974C18.9062 18.2473 18.9062 18.656 19.1917 18.8058L26.6851 22.7388C26.9514 22.8786 27.271 22.6854 27.271 22.3846L27.271 14.5186C27.271 14.2178 26.9514 14.0246 26.6851 14.1644L19.1917 18.0974Z",
    stroke: "#979794",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19168 18.0974C8.90621 18.2473 8.90621 18.656 9.19168 18.8058L16.6851 22.7388C16.9514 22.8786 17.271 22.6854 17.271 22.3846L17.271 14.5186C17.271 14.2178 16.9514 14.0246 16.6851 14.1644L9.19168 18.0974Z",
    stroke: "#979794",
    strokeWidth: 1.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: 0.6,
    width: 36.2194,
    height: 36.2194,
    rx: 18.1097,
    transform: "matrix(-1 0 0 1 36.2194 0)",
    stroke: "#979794",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevIcon);
export default __webpack_public_path__ + "static/media/prev-icon.07e7f7696e2a319d2f405e29444ccaef.svg";
export { ForwardRef as ReactComponent };